import toggle_class from "../dom/toggle_class"
import register_dom_update from "../navigation/register_dom_update"
import user from "../state/user"

function update_body_classes() {
  // adding cookie law banner logic
  // const cookielaw_big = window.location.hash == "#/accept-cookie"
  // toggle_class(
  //     document.body,
  //     "body-cookielaw",
  //     !state.cookielaw && !cookielaw_big
  // )
  // toggle_class(
  //     document.body,
  //     "body-cookielaw-big",
  //     !state.cookielaw && cookielaw_big
  // )

  // other body classes
  toggle_class(document.body, {
    "body-loading": false,
    // @ts-expect-error TS2339
    "body-staff": user.is_just_staff,
    // @ts-expect-error TS2339
    "body-user": user.is_just_user,
  })
}

register_dom_update({
  after: update_body_classes,
  login: update_body_classes,
  logout: update_body_classes,
})
